import { combineReducers } from 'redux';
import numberReducer from './numberReducer';
import contactsReducer from './contactsReducer';
import templatesReducer from './templatesReducer';

// In redux this is where we combine the states

export default combineReducers({
    number: numberReducer,
    contacts: contactsReducer,
    templates: templatesReducer
})